import React from 'react';
import { ArrowRight } from 'lucide-react';
import Button from '../../common/Button';

interface MigrationHeroContentProps {
  title: string;
  description: string;
  buttonText: string;
}

const MigrationHeroContent: React.FC<MigrationHeroContentProps> = ({
  title,
  description,
  buttonText
}) => {
  return (
    <div>
      <h3 className="text-2xl font-semibold text-gray-800">{title}</h3>
      <p className="mt-4 text-gray-600">{description}</p>
      <div className="mt-8">
        <Button 
          variant="primary" 
          icon={ArrowRight}
          onClick={() => document.getElementById('contact')?.scrollIntoView({ behavior: 'smooth' })}
        >
          {buttonText}
        </Button>
      </div>
    </div>
  );
};

export default MigrationHeroContent;